import { WizardStepItem } from 'src/app/shared/models/wizard-step-item';
import { SingleOrderArticledataComponent } from './single-order-articledata/single-order-articledata.component';
import { SingleOrderMasterdataComponent } from './single-order-masterdata/single-order-masterdata.component';
import { SingleOrderSummaryComponent } from './single-order-summary/single-order-summary.component';

const WIZARD_ITEMS: WizardStepItem[] = [];

WIZARD_ITEMS.push(new WizardStepItem('order.edit.sections.masterdata', SingleOrderMasterdataComponent));
WIZARD_ITEMS.push(new WizardStepItem('order.edit.sections.articledata', SingleOrderArticledataComponent));
WIZARD_ITEMS.push(new WizardStepItem('order.edit.sections.summary', SingleOrderSummaryComponent));

export default WIZARD_ITEMS;
